import { fillUserInfo, getAllUserInfo } from '@common/application/getUserInfo';
import { setCookie } from '@common/stores/cookie';
import { msSessionStorage } from '@common/utils/cache';

export default async (refresh = false) => {
  let userInfo = getAllUserInfo();
  if (!userInfo.userId || refresh) {
    await fillUserInfo();
    userInfo = getAllUserInfo();
  }
  if (userInfo.userId) {
    msSessionStorage.set('PUBLIC_USERID', userInfo.userId);
    msSessionStorage.set('PUBLIC_UNIQUEID', userInfo.uniqueId);
    setCookie('X-UserId', userInfo.userId);
  }
};
